import React, { useState, useEffect } from 'react';
import { useDataProvider, useNotify } from 'react-admin';

interface ImageState {
  id: string | null;
  url: string | null;
  localUrl: string | null;
  file: null | any;
}
interface Props {
  image: ImageState;
}

const useCharityImage = (props: Props) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [image, setImage] = useState<ImageState>({
    id: props.image.id,
    url: props.image.url,
    localUrl: props.image.localUrl,
    file: props.image.file,
  });
  const [isUploading, setIsUploading] = useState(false);
  const [needRemoveImage, setNeedRemoveImage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const uploadImage = async (charityId: string, file) => {
    try {
      setError('');
      console.log('Start uploading image: ', image);
      let response = await dataProvider.storeCharityImageAsync(charityId, [
        file,
      ]);
      console.log('response: ', response.data);
    } catch (err: any) {
      console.error('Err image uploading: ', JSON.stringify(err));
      setError(JSON.stringify(err));
      notify(`Err image uploading: ${JSON.stringify(err)}`, 'error');
    } finally {
      //   setIsUploading(false);
      //   setIsUploaded(false);
    }
  };

  const selectImage = (files) => {
    if (files && files.length) {
      let file = files[0];
      if (file) {
        const url = URL.createObjectURL(file);
        if (url) {
          setImage({
            id: file.name,
            localUrl: url,
            url: null,
            file: file,
          });
        }
      }
    }
  };
  const removeImage = () => {
    setImage({
      id: null,
      url: null,
      localUrl: null,
      file: null,
    });
    if (image.url) {
      setNeedRemoveImage(true);
    }
  };

  useEffect(() => {
    console.log('image: ', image);
  }, [image]);

  return {
    error,
    isUploading,
    image,
    loading,
    needRemoveImage,
    setLoading,
    setImage,
    setError,
    setIsUploading,
    uploadImage,
    selectImage,
    removeImage,
  };
};

export default useCharityImage;
